module.exports = __webpack_public_path__ + "static/media/tier-7.56291229.jpg";